define('settings/settings',[], function () {
    return window.config;
});

